// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { ProductCard } from '../../../components/NewCard/types';
import { ProductHistoryRow } from '../../../pages/HomePage/components/HistoryTable';
import { CardTypes, CompletionStatusType } from '../../../types/Model';
import { IProduct } from '../../actionCreators/home/getHomeActions';

import { RootState } from '../../rootReducer';

export const homeRaw = (state: RootState) => state.homeReducer;

export const makeHomeMyCourse = (): Selector<RootState, ProductCard[]> => {
  return createSelector(
    homeRaw,
    (home) => home.list
      .map((card: IProduct) => {
        if (card.type === CardTypes.WORKSHOP) {
          return {
            ...card,
            completionStatus: card.endTime.getTime() - new Date().getTime() > 0 ?
              card.completionProgress === 1 ? CompletionStatusType.COMPLETED : CompletionStatusType.INCOMPLETE
              : CompletionStatusType.ENDED
          }
        } else if (card.type === CardTypes.COURSE) {
          return {
            ...card,
            completionStatus: card.completionProgress === 1 ? CompletionStatusType.COMPLETED : CompletionStatusType.INCOMPLETE
          }
        } else {
          return {
            ...card,
            completionStatus: CompletionStatusType.COMPLETED
          }
        }
      })
      .filter((card: IProduct & ProductHistoryRow) => {
        if (card.type === CardTypes.WORKSHOP && card.completionStatus === CompletionStatusType.ENDED) {
          return false;
        }
        return true;
      })
      .sort((a: IProduct & ProductHistoryRow, b: IProduct & ProductHistoryRow) => {
        const completionStatusPriority = [
          CompletionStatusType.INCOMPLETE,
          CompletionStatusType.ENDED,
          CompletionStatusType.COMPLETED,
        ]
        const indexA = completionStatusPriority.indexOf(a.completionStatus);
        const indexB = completionStatusPriority.indexOf(b.completionStatus);

        // return completionStatusPriority.indexOf(a.completionStatus) - completionStatusPriority.indexOf(b.completionStatus);

        if (indexA !== indexB) {
          return indexA - indexB
        }

        const priority = [
          CardTypes.WORKSHOP,
          CardTypes.COURSE,
          CardTypes.CHALLENGE,
          CardTypes.LAB,
          CardTypes.EXAM
        ]
        if (a.type !== b.type) {
          return priority.indexOf(a.type) - priority.indexOf(b.type)
        }
        if (a.type === CardTypes.WORKSHOP && b.type === CardTypes.WORKSHOP
          || a.type === CardTypes.COURSE && b.type === CardTypes.COURSE) {
          if (a.latestTime === null) {
            return 1;
          } else if (b.latestTime === null) {
            return 0
          }
          return a.latestTime.getTime() - b.latestTime.getTime();
        }

        return 0;
      })
  );
};

export const makeHomeHistory = (): Selector<RootState, ProductHistoryRow[]> => {
  return createSelector(
    homeRaw,
    (home) => home.list
      .map((card: IProduct) => {
        if (card.type === CardTypes.WORKSHOP) {
          return {
            ...card,
            completionStatus: card.endTime.getTime() - new Date().getTime() > 0 ?
              card.completionProgress === 1 ? CompletionStatusType.COMPLETED : CompletionStatusType.INCOMPLETE
              : CompletionStatusType.ENDED
          }
        } else if (card.type === CardTypes.COURSE) {
          return {
            ...card,
            completionStatus: card.completionProgress === 1 ? CompletionStatusType.COMPLETED : CompletionStatusType.INCOMPLETE
          }
        } else {
          return {
            ...card,
            completionStatus: CompletionStatusType.COMPLETED
          }
        }
      })
      .sort((a: IProduct & ProductHistoryRow, b: IProduct & ProductHistoryRow) => {
        if (home.sorting === undefined) {
          return 0;
        }

        const cardTypePriority = [
          CardTypes.WORKSHOP,
          CardTypes.COURSE,
          CardTypes.CHALLENGE,
          CardTypes.LAB,
          CardTypes.EXAM
        ]
        const completionStatusPriority = [
          CompletionStatusType.COMPLETED,
          CompletionStatusType.ENDED,
          CompletionStatusType.INCOMPLETE
        ]

        if (!home.sorting.isAscending) {
          [a, b] = [b, a]; // swap
        }

        switch (home.sorting.sortingKey) {
          case 'type': // CardTypes;
            return cardTypePriority.indexOf(a.type) - cardTypePriority.indexOf(b.type)
          case 'name': // string;
            return a.name.localeCompare(b.name);
          case 'platformId': // number;
            return a.platformId - b.platformId;
          case 'levelId': // number;
            return a.levelId - b.levelId;
          case 'completionStatus': // CompletionStatus;
            return completionStatusPriority.indexOf(a.completionStatus) - completionStatusPriority.indexOf(b.completionStatus);
          case 'completionTime': // Date | null;
            if (a.completionTime === null) { // null is last order
              return home.sorting.isAscending ? 1 : -1;
            }
            if (b.completionTime === null) { // null is last order
              return home.sorting.isAscending ? -1 : 1;
            }
            return b.completionTime.getTime() - a.completionTime.getTime();
          default:
            return 0;
        }
      })
  );
};

export const makeHomeIsFetching = (): Selector<RootState, boolean> => {
  return createSelector(
    homeRaw,
    (home) => home.isFetching
  );
};

export const makeHomeSortingKey = (): Selector<RootState, keyof ProductHistoryRow | undefined> => {
  return createSelector(
    homeRaw,
    (home) => home.sorting ? home.sorting.sortingKey : undefined
  );
};

export const makeHomeIsAscending = (): Selector<RootState, boolean | undefined> => {
  return createSelector(
    homeRaw,
    (home) => home.sorting ? home.sorting.isAscending : undefined
  );
};

export const makeError = (): Selector<RootState, string | undefined> => {
  return createSelector(
    homeRaw,
    (home) => home.homeError
  );
};
